import { render, staticRenderFns } from "./lawyer.vue?vue&type=template&id=692c3434&scoped=true&"
import script from "./lawyer.vue?vue&type=script&lang=js&"
export * from "./lawyer.vue?vue&type=script&lang=js&"
import style0 from "./lawyer.vue?vue&type=style&index=0&id=692c3434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692c3434",
  null
  
)

export default component.exports